import React, { createContext, useContext, useEffect, useState } from 'react'
import { isMultistepQuiz } from '@/helpers/isMultistepQuiz'

type Theme = 'light' | 'dark'

interface ThemeContextProps {
  theme: Theme
  setTheme: (theme: Theme) => void
}

const ThemeContext = createContext<ThemeContextProps>({
  theme: 'dark',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setTheme: () => {},
})

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const savedTheme = (localStorage.getItem('data-theme') as Theme) || ('dark' as Theme)
  const [theme, setThemeState] = useState<Theme>(savedTheme)
  const [version, setVersion] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const queryTheme = params.get('theme') as Theme | null
    if (queryTheme === 'light' || queryTheme === 'dark') {
      setThemeState(queryTheme)
    }
    if (window.location.pathname.startsWith('/new')) {
      setVersion('brand')
    }
    if (window.location.pathname.startsWith('/quiz') || isMultistepQuiz()) {
      setVersion('multiStepQuiz')
      setThemeState('light')
    }
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    document.documentElement.setAttribute('data-version', version)
    localStorage.setItem('data-theme', theme)
  }, [theme, version])

  return (
    <ThemeContext.Provider value={{ theme, setTheme: setThemeState }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)
